module.exports = __webpack_public_path__ + "img/celo.852eeb14.png";